import { APP_CONFIG } from '../constants/global-variables.js';
export async function liveCasinoCheck() {
    const url = `${APP_CONFIG.URL.apiBasePath}livecasino`;

    try {
        const res = await axios.post(url, {}, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                "Content-Type": "application/json",
            },
        });
        return res.data;
    } catch (err) {

    }
}


export async function registerFirstTime() {
    const url = `${APP_CONFIG.URL.apiBasePath}livecasinoslots/register`;

    try {
        const res = await axios.post(url, {},
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return res.data;
    } catch (err) {

    }
}

export async function gotoGame() {
    const url = `${APP_CONFIG.URL.apiBasePath}livecasinoslots/gotogame`;

    try {
        const res = await axios.post(url, {}, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                "Content-Type": "application/json",
            },
        });
        return res.data;
    } catch (err) {

    }
}

export async function sgLiveCasinoCheck() {
    const url = `${APP_CONFIG.URL.apiBasePath}livecasino`;

    try {
        const res = await axios.post(url, {}, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                "Content-Type": "application/json",
            },
        });
        return res.data;
    } catch (err) {

    }
}


export async function sgRegisterFirstTime() {
    const url = `${APP_CONFIG.URL.apiBasePath}slots/register`;

    try {
        const res = await axios.post(url, {},
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return res.data;
    } catch (err) {

    }
}

export async function sgGotoGame() {
    const url = `${APP_CONFIG.URL.apiBasePath}slots/gotogame`;

    try {
        const res = await axios.post(url, {}, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                "Content-Type": "application/json",
            },
        });
        return res.data;
    } catch (err) {

    }
}

export async function evoRegisterFirstTime() {
    const url = `${APP_CONFIG.URL.apiBasePath}evolutionslots/register`;

    try {
        const res = await axios.post(url, {},
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return res.data;
    } catch (err) {

    }
}

export async function evoGoToGame() {
    const url = `${APP_CONFIG.URL.apiBasePath}evolutionslots/gotogame`;

    try {
        const res = await axios.post(url, {}, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                "Content-Type": "application/json",
            },
        });
        return res.data;
    } catch (err) {

    }
}